import { VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useBlockListActions } from '../../../store/blockList/actions';
import { blockListConfirmTokenState } from '../../../store/blockList/atom';

import { Feedback } from './components/Feedback';

export namespace UnlockConfirmationTypes {
  export type Props = object;
}

export const UnlockConfirmation = () => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
  });

  const urlParams = new URLSearchParams(window.location.search);
  const [confirmationToken] = useState(urlParams.get('confirmationToken'));
  const decoded = confirmationToken && Utils.Jwt.Validate(confirmationToken);
  const isExpired = decoded && Utils.Jwt.Expired(confirmationToken);

  const { sendToken } = useBlockListActions();
  const confirmTokenState = useRecoilValue(blockListConfirmTokenState);

  const [feedbackContent, setFeedbackContent] = useState(
    'loading' as 'loading' | 'confirmed' | 'expired'
  );

  const validateToken = confirmationToken?.length && decoded && !isExpired;

  useEffect(() => {
    if (validateToken) {
      sendToken(confirmationToken);
    } else {
      setFeedbackContent('expired');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (validateToken) {
      if (confirmTokenState.isLoading) {
        setFeedbackContent('loading');
      } else if (confirmTokenState.isExpired) {
        setFeedbackContent('expired');
      } else if (confirmTokenState.isConfirmed) {
        setFeedbackContent('confirmed');
      } else {
        setFeedbackContent('loading');
      }
    } else {
      setFeedbackContent('expired');
    }
  }, [confirmTokenState, decoded, feedbackContent, isExpired, validateToken]);

  return (
    <VStack flex={1}>
      <Box width={'100%'} background={'#011367'} zIndex={-1} height={'40%'} />
      <Box
        borderRadius={'md'}
        backgroundColor={Color['neutral.white']}
        shadow={2}
        zIndex={1}
        height={'45%'}
        width={isMobile ? '95%' : '80%'}
        position={'absolute'}
        top={'25%'}
        left={isMobile ? '2.5%' : '10%'}
        right={isMobile ? '2.5%' : '10%'}
        alignItems={'center'}
        justifyContent={'center'}
        maxWidth={'1200px'}
        marginX={'auto'}>
        <VStack alignItems={'center'} width={'100%'} padding={isMobile ? 0 : Spacing['stack.sm']}>
          <Feedback isMobile={isMobile} currentFeedback={feedbackContent} />
        </VStack>
      </Box>

      <Box width={'100%'} zIndex={-1} background={Color['neutral.white']} height={'60%'} />
    </VStack>
  );
};
